import { ControllerSelectionRayVisibilityMessage, ControllerVisibilityMessage, ResetControllerButtonDescription, SetControllerButtonDescription } from "../../../messages/controller/ControllerMessages";
import { BroadcastToPeerMessage, EnableControllerAnnotationMessage, PeersSelectionVisibilityMessage, DetachModelMessage, EnableControllerJoystickMessage, } from "flavr-common";
import { scriptService } from "../services/ScriptService";
import { xrControllerService } from "../../xr/XRControllerService";
import { resolveUid } from "../model/Utils";
import { modelPool } from "@modules/model";
import { EnableControllerSelectionMessage } from "../../../messages/selection/SelectionStrategyMessages";
import { EnableTeleportMessage } from "../../../messages/locomotion/LocomotionMessages";
import { AttachToModelMessage } from "../../../messages/attachment/AttachmentMessage";
export class ScriptController {
    static showVrHand(_visible) {
        if (!scriptService.context)
            return;
    }
    static showVrController(visible) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new ControllerVisibilityMessage(visible));
    }
    static showSelection(visible, uid) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new ControllerSelectionRayVisibilityMessage(visible, uid));
        scriptService.context.pendingMessages.push(new BroadcastToPeerMessage([new PeersSelectionVisibilityMessage(visible, uid)]));
    }
    static enableSelection(enabled, modelUid) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new EnableControllerSelectionMessage(enabled, modelUid));
    }
    static enableTeleport(enabled, hand) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new EnableTeleportMessage(enabled, hand));
    }
    static setButtonDescription(buttonType, description, controllerUid) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new SetControllerButtonDescription(buttonType, description, controllerUid));
    }
    static resetButtonDescription(controllerUid, buttonType) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new ResetControllerButtonDescription(controllerUid, buttonType));
    }
    static enableAnnotation(enable) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new EnableControllerAnnotationMessage(enable));
    }
    static getControllers() {
        return xrControllerService.getControllers();
    }
    // Enables or disables the joystick of this controller
    static enableJoystick(enable, hand) {
        if (!scriptService.context)
            return;
        scriptService.context.pendingMessages.push(new EnableControllerJoystickMessage(enable, hand));
    }
    static attach(uid, controllerUID, offset) {
        if (!scriptService.context)
            return false;
        try {
            uid = resolveUid(uid);
            controllerUID = resolveUid(controllerUID);
        }
        catch (_a) {
            return false;
        }
        if (modelPool.getModel(uid) === undefined || modelPool.getModel(controllerUID) === undefined) {
            return false;
        }
        scriptService.context.connection.send(new AttachToModelMessage(uid, controllerUID, offset));
    }
    static detach(modelUid) {
        if (!scriptService.context)
            return false;
        modelUid = resolveUid(modelUid);
        scriptService.context.connection.send(new DetachModelMessage(modelUid));
    }
}
